export function normalizeName(text: string | null): string | null {
    if (!text) return null;
    return text.replace(/^\d+_/, "")
}